import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './Components/ProtectedRoute';
import { TokenProvider } from './Components/TokenContext';

import Login from './pages/Login';
import Home from './pages/Home';
import Docs from './pages/Docs';
import Users from './pages/Users';
import AddUser from './pages/AddUser';
import EditUser from './pages/EditUser';

const App = () => {
    return (
        <TokenProvider>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<ProtectedRoute element={<Home />} />} />
                    <Route path="/impressao-de-documentos" element={<ProtectedRoute element={<Docs />} />} />
                    <Route path="/usuarios" element={<ProtectedRoute element={<Users />} />} />
                    <Route path="/usuarios/adicionar" element={<ProtectedRoute element={<AddUser />} />} />
                    <Route path="/usuarios/editar/:id" element={<ProtectedRoute element={<EditUser />} />} />
                </Routes>
            </Router>
        </TokenProvider>
    );
};

export default App;